import React, { useState } from "react";

const LegalService = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6 md:px-16 lg:px-28">
      <div className="max-w-5xl mx-auto bg-white shadow-md rounded-2xl p-8 border border-gray-100">
        {/* Tabs */}
        <div className="flex justify-center mb-8">
          <button
            onClick={() => setActiveTab("overview")}
            className={`px-6 py-2 rounded-l-xl font-medium transition ${
              activeTab === "overview"
                ? "bg-gray-800 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Overview
          </button>
          <button
            onClick={() => setActiveTab("services")}
            className={`px-6 py-2 rounded-r-xl font-medium transition ${
              activeTab === "services"
                ? "bg-gray-800 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
          >
            Legal Services
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "overview" && (
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">
              Meet Our Expert{" "}
              <span style={{ color: "#b7b7a1" }}>Legal Team – Here to Serve You</span>
            </h1>
            <p>
              Dear Valued Customers, <br />
              We understand that navigating the complexities of legal matters can be
              overwhelming. That's why we have collaborated with a dedicated legal team
              from different fields. Our experience has made us choose the right lawyer
              for our clients based on their requirements, one who will provide you with
              the expert guidance and support you need.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2">Why Choose Our Legal Team?</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Experienced Professionals:</strong> Our team consists of seasoned
                attorneys with diverse backgrounds in various areas of law.
              </li>
              <li>
                <strong>Personalized Service:</strong> We understand that each client has
                unique needs. Our tailored approach meets your situation, ensuring you
                receive the most effective legal solutions.
              </li>
              <li>
                <strong>Proven Track Record:</strong> Our commitment to excellence has
                resulted in numerous successful outcomes for our clients.
              </li>
              <li>
                <strong>Transparent Communication:</strong> We believe in keeping our
                clients informed every step of the way. Our legal team will clarify
                processes, answer your questions, and guide you fully.
              </li>
              <li>
                <strong>Commitment to Ethics:</strong> Our practice is built on integrity
                and professionalism. We uphold the highest ethical standards in all our
                dealings.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">Get Started Today</h2>
            <p>
              If you’re facing legal challenges or need advice on navigating a legal
              issue, our team is here to help. We invite you to reach out for a
              consultation and discover how our legal expertise can benefit you.
            </p>
          </div>
        )}

    {activeTab === "services" && (
  <div className="space-y-6 text-gray-700 leading-relaxed">
    <h2 className="text-2xl font-bold text-gray-800 mb-4">
      Legal Services We Offer
    </h2>
    <p>(Our services are vast; we mentioned only a few below.)</p>

    <ol className="list-decimal pl-6 space-y-4">
      <li>
        <strong>Property Transactions</strong>
        <ul className="list-disc pl-6">
          <li>Title Verification: Checking the legal title of the property being sold or purchased.</li>
          <li>Drafting and Reviewing Agreements: Preparing sale deeds, lease deeds, mortgage deeds, and other contracts related to property transactions.</li>
          <li>Registration of Documents: Assisting in registering property documents with the relevant authorities.</li>
          <li>Due Diligence: Conduct thorough due diligence to ensure no encumbrances, disputes, or legal issues related to the property.</li>
        </ul>
      </li>

      <li>
        <strong>Property Litigation</strong>
        <ul className="list-disc pl-6">
          <li>Filing and Defending Suits: Representing clients in disputes related to property, such as suits for specific performance, possession, and recovery of money.</li>
          <li>Eviction Proceedings: Handling eviction cases for landlords or tenants.</li>
          <li>Property Disputes: Appearing in civil courts, district courts, and High Courts for cases related to property disputes, including partition suits and ownership claims.</li>
          <li>Seeking Injunctions: Filing applications seeking stay or injunctions against unlawful dispossession or construction.</li>
        </ul>
      </li>

      <li>
        <strong>Real Estate Development</strong>
        <ul className="list-disc pl-6">
          <li>Legal Compliance: Advising developers on compliance with real estate laws, environmental regulations, and municipal regulations.</li>
          <li>Intellectual Property Rights: Protecting trademarks and patents for projects and developments.</li>
          <li>Project Documentation: Drafting joint venture agreements, brochures, and other documentation for real estate projects.</li>
        </ul>
      </li>

      <li>
        <strong>Leasing and Rentals</strong>
        <ul className="list-disc pl-6">
          <li>Drafting Lease Agreements: Preparing residential and commercial lease agreements, including terms and conditions.</li>
          <li>Dispute Resolution: Addressing disputes related to rentals, including non-payment of rent and damage to property.</li>
        </ul>
      </li>

      <li>
        <strong>Mortgage and Financing</strong>
        <ul className="list-disc pl-6">
          <li>Advising on Mortgages: Providing legal advice on property mortgages and loans.</li>
          <li>Drafting Mortgage Documents: Preparing mortgage deeds and agreements with banks and financial institutions.</li>
        </ul>
      </li>

      <li>
        <strong>Inheritance and Succession</strong>
        <ul className="list-disc pl-6">
          <li>Wills and Estate Planning: Drafting wills for property distribution and advising on estate planning.</li>
          <li>Probate Matters: Assisting in obtaining probate or letters of administration for property inheritance.</li>
        </ul>
      </li>

      <li>
        <strong>Property Tax and Regulatory Issues</strong>
        <ul className="list-disc pl-6">
          <li>Tax Advice: Advising on property tax assessments, disputes with tax authorities, and compliance with municipal regulations.</li>
          <li>Government Approvals: Assisting in obtaining necessary permissions and approvals from local authorities for construction and modifications.</li>
        </ul>
      </li>

      <li>
        <strong>RERA Compliance</strong>
        <ul className="list-disc pl-6">
          <li>Advising on RERA Compliance: Ensuring compliance with the Real Estate (Regulation and Development) Act, including project registration and promoter obligations.</li>
        </ul>
      </li>

      <li>
        <strong>Advisory Services</strong>
        <ul className="list-disc pl-6">
          <li>Real Estate Investments: Providing legal advice to investors regarding the legal aspects of real estate investment.</li>
          <li>Negotiation Support: Assisting clients in negotiating property purchases, sales, and leases.</li>
        </ul>
      </li>

      <li>
        <strong>Alternative Dispute Resolution</strong>
        <ul className="list-disc pl-6">
          <li>Mediation and Arbitration: Representing clients in mediation and arbitration related to property disputes as an alternative to litigation.</li>
        </ul>
      </li>
    </ol>

    <h2 className="text-2xl font-semibold mt-6 mb-2">Conclusion</h2>
    <p>
      Given the complexity of real estate laws and property transactions in India,
      individuals and businesses should seek legal assistance to navigate these
      processes effectively. Lawyers play a crucial role in safeguarding interests
      and ensuring compliance with the law.
    </p>
    <p className="font-semibold text-gray-800">
      Thank you for placing your trust in us. We look forward to providing the
      quality legal services you deserve.
    </p>
  </div>
)}

      </div>
    </div>
  );
};

export default LegalService;
